import _toConsumableArray from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/toConsumableArray';
import _Set from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/set';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/plugins/axios.js';
export default {
  name: 'PendingApproveEditUserInfo',
  data: function data() {
    return {
      pendingApprovalUserList: [],
      tableFields: {
        fullname: {
          key: 'fullname',
          label: 'Name'
        },
        username: {
          key: 'username',
          label: 'UserName'
        },
        password: {
          key: 'password',
          label: 'Password'
        },
        nricFin: {
          key: 'nricFin',
          label: 'NRIC/FIN'
        },
        companyName: {
          key: 'companyName',
          label: 'Company',
          sortable: true
        },
        editted: {
          key: 'editted',
          label: 'New Info'
        },
        Action: {
          key: 'action',
          label: 'Action'
        }
      }
    };
  },
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var pendingApprovalUserList;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.post('/users/pendingApproveUserEdited');

            case 2:
              pendingApprovalUserList = _context.sent.data;

              console.log('\n\n ======== PendingApproveEditUserInfo.vue <|-- mounted() ======= \n', pendingApprovalUserList, '\n----------------------');
              this.pendingApprovalUserList = !!pendingApprovalUserList.length ? pendingApprovalUserList : [];

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),


  methods: {
    confirmNewInfo: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(user, button) {
        var userActorId, isApproved, infoReturned, tempSet;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('\n\n ======== PendingApproveEditUserInfo <|-- Row User =======\n', user, '\n----------------------');

                console.log('\n\n ======== PendingApproveEditUserInfo <|-- Row User =======\n', button.innerText.trim(), '\n----------------------');

                userActorId = user.id;
                isApproved = button.innerText.trim();
                _context2.next = 6;
                return axios.post('/managing/approveUserEdited', {
                  userActorId: userActorId,
                  isApproved: isApproved
                });

              case 6:
                infoReturned = _context2.sent.data;


                console.log('\n\n ======== PendingApproveEditUserInfo <|-- infoReturned =======\n', infoReturned, '\n----------------------');

                alert(infoReturned.edittedApprove ? 'Approved Update' : 'Rejected Update');
                tempSet = new _Set(this.pendingApprovalUserList);

                tempSet.delete(user);
                this.pendingApprovalUserList = [].concat(_toConsumableArray(tempSet));

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function confirmNewInfo(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return confirmNewInfo;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/PendingApproveEditUserInfo.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/PendingApproveEditUserInfo.vue
// module chunks = 0